import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import clsx from "clsx";
import Logo from "../../components/header/Logo";
import NavMenu from "../../components/header/NavMenu";
import IconGroup from "../../components/header/IconGroup";
import MobileMenu from "../../components/header/MobileMenu";
import { useStoreInfo } from "../../hooks/storeInfoHooks/useStoreInfo";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const HeaderOne = ({
  layout,

  headerPaddingClass,
  headerPositionClass,
  headerBgClass,
}) => {
  const [scroll, setScroll] = useState(0);
  const [headerTop, setHeaderTop] = useState(0);
  const { data: storeInfo, isLoading: isLoadingStoreInfo } = useStoreInfo();

  useEffect(() => {
    const header = document.querySelector(".sticky-bar");
    setHeaderTop(header.offsetTop);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <header
      className={clsx(
        "header-area clearfix",
        headerBgClass,
        headerPositionClass
      )}
    >
      {/* <div
        className={clsx(
          "header-top-area",
          headerPaddingClass,
          top === "visible" ? "d-none d-lg-block" : "d-none",
          borderStyle === "fluid-border" && "border-none"
        )}
      >
        <div className={layout === "container-fluid" ? layout : "container"}>
          <HeaderTop borderStyle={borderStyle} />
        </div>
      </div> */}

      <div
        className={clsx(
          headerPaddingClass,
          "sticky-bar header-res-padding clearfix py-2 shadow-sm",
          scroll > headerTop && "stick py-0 shadow-lg"
        )}
      >
        <div
          className={
            layout === "container-fluid" ? layout : "container md:px-0"
          }
        >
          <div className="row align-items-center px-1">
            <div className="col-md-2 col-4 p-0">
              {/* header logo */}
              {isLoadingStoreInfo ? (
                <Skeleton height={"50px"} width={"90px"} />
              ) : (
                <Logo
                  imageUrl={`${import.meta.env.VITE_REACT_APP_API_URL}/${
                    storeInfo?.[0]?.logo
                  }`}
                  logoClass="logo"
                  width="80px"
                  height="80px"
                />
              )}
            </div>
            <div className="col-md-6 d-none d-md-block p-0">
              {/* Nav menu */}
              <NavMenu />
            </div>
            <div className="col-md-4 col-8 mt-0 p-0">
              {/* Icon group */}
              <IconGroup />
            </div>
          </div>
        </div>
        {/* mobile menu */}
        <MobileMenu />
      </div>
    </header>
  );
};

HeaderOne.propTypes = {
  borderStyle: PropTypes.string,
  headerPaddingClass: PropTypes.string,
  headerPositionClass: PropTypes.string,
  layout: PropTypes.string,
  top: PropTypes.string,
};

export default HeaderOne;
